import { BH_SEARCH_ID } from '../../../constants'

export const getConstantParams = ({ userUniqueId, isLoggedIn, getCookiesByStore }) => {
	const cookies = getCookiesByStore()
	return {
		searchId: cookies[BH_SEARCH_ID],
		userId: userUniqueId,
		userIsLoggedIn: isLoggedIn,
	}
}
